import reducer from './reducers';
import * as appointmentFlowsActions from './actions';
import * as appointmentFlowsSelectors from './selectors';

export { appointmentFlowsActions, appointmentFlowsSelectors };
export default reducer;